import mr_icon from "../../assets/img/recept_checkin/man.svg";
import mrs_icon from "../../assets/img/recept_checkin/girl.svg";
import users_icon from "../../assets/img/recept_checkin/users.svg";

export const userTitle =
  [
    {
      key: 0, text: 'Mr.', value: 'Mr',
      image: {avatar: true, src: mr_icon},
    },
    {
      key: 1, text: 'Mrs.', value: 'Mrs',
      image: {avatar: true, src: mrs_icon},
    },
    {
      key: 2, text: 'Miss.', value: 'Miss',
      image: {avatar: true, src: mrs_icon},
    },
    {
      key: 3, text: 'Ms.', value: 'Ms',
      image: {avatar: true, src: mrs_icon},
    },
    {
      key: 4, text: 'Dr.', value: 'Dr',
      image: {avatar: true, src: users_icon},
    },

    {
      key: 5, text: 'Ven.', value: 'Ven',
      image: {avatar: true, src: users_icon},
    },
  ];

export const gender =
  [
    {
      key: 0, text: 'Male', value: 'Male',
      image: {avatar: true, src: mr_icon},
    },
    {
      key: 1, text: 'Female', value: 'Female',
      image: {avatar: true, src: mrs_icon},
    },
  ];

  export const status =
  [
    {
      key: 0, text: 'PENDING', value: 'PENDING',
    },
    {
      key: 1, text: 'PROCESSING', value: 'PROCESSING',
    },
    {
      key: 2, text: 'CLOSED', value: 'CLOSED',
    },
  ];

export const Identifications = (t=null) => {
    return [
        {
            key: 0, text: t !== null ? t('nic') : 'NIC', value: 'NIC',
        },
        {
            key: 1, text: t !== null ? t('driving_licence') : 'Driving Licence', value: 'Driving Licence',
        },
        {
            key: 2, text: t !== null ? t('passport_number') : 'Passport Number', value: 'Passport',
        },
    ];
}

export const IdentificationsHostAdvanced =
  [
    {
      key: 0, text: 'NIC', value: 'NIC',
    },
    {
      key: 1, text: 'Email', value: 'Email',
    },
    {
      key: 2, text: 'Mobile', value: 'Mobile',
    },
    {
      key: 3, text: 'Driving Licence', value: 'Driving Licence',
    },
    {
      key: 4, text: 'Passport Number', value: 'Passport',
    },
    {
      key: 5, text: 'Vehicle Number', value: 'Vehicle Number',
    }
  ];

export const IdentificationsHostWithoutVN = (t=null) => {
  return [
    {
      key: 0, text: t !== null ? t('nic') : 'NIC', value: 'NIC',
    },
    {
      key: 1, text: t !== null ? t('email') : 'Email', value: 'Email',
    },
    {
      key: 2, text: t !== null ? t('mobile') : 'Mobile', value: 'Mobile',
    },
    {
      key: 3, text: t !== null ? t('driving_licence') : 'Driving Licence', value: 'Driving Licence',
    },
    {
      key: 4, text: t !== null ? t('passport_number') : 'Passport Number', value: 'Passport',
    }
  ];
}

export const UserTypeDetails =
  [
    {
      key: 0, text: 'Public Users', value: 'PUBLIC',
    },
    {
      key: 1, text: 'Corporate Users', value: 'CORPORATE',
    },
    {
      key: 2, text: 'VIP Users', value: 'VIP',
    },
  ];


export const filterUserRoles =
  [
    {
      key: 0, text: 'All', value: 'ALL',
    },
    {
      key: 1, text: 'Corporate Admin', value: 'CORP_ADMIN',
    },
    {
      key: 2, text: 'Human Resources', value: 'HR'
    },
    {
      key: 3, text: 'Corporate Operator', value: 'CORP_OPER',
    },
    {
      key: 4, text: 'ParkTags Admin', value: 'PARK_ADMIN',
    },
    {
      key: 5, text: 'ParkTags Operator', value: 'PARK_OPER',
    },
    {
      key: 6, text: 'ParkTags Receptionist', value: 'PARK_RECEPTION',
    },
    {
      key: 7, text: 'EventTags Admin', value: 'CORP_EVENT_ADMIN',
    },
    {
      key: 8, text: 'EventTags Organizer', value: 'CORP_EVENT_ORGANIZER',
    },
    {
      key: 9, text: 'System Operator', value: 'SYS_OPER',
    },
    {
      key: 10, text: 'Notification Operator', value: 'NOTIFICATION_OPERATOR',
    },
    {
      key: 11, text: 'ParkTags User', value: 'PARK_USER',
    },
    {
      key: 12, text: 'Help Desk', value: 'HELP_DESK',
    },
    {
      key: 13, text: 'IVCA', value: 'IVCA'
    },
    {
      key: 14, text: 'Head Usher', value: 'HEAD_USHER',
    },
    {
      key: 15, text: 'Usher', value: 'USHER'
    },
    {
      key: 16, text: 'Security', value: 'SECURITY'
    },
  ];

export const userRoles =
  [
    {
      key: 1, text: 'Corporate Admin', value: 'CORP_ADMIN',
    },
    {
      key: 2, text: 'Human Resources', value: 'HR'
    },
    {
      key: 3, text: 'Corporate Operator', value: 'CORP_OPER',
    },
    {
      key: 4, text: 'Park Admin', value: 'PARK_ADMIN',
    },
    {
      key: 5, text: 'Park Operator', value: 'PARK_OPER',
    },
    // {
    //   key: 6, text: 'ParkTags Receptionist', value: 'PARK_RECEPTION',
    // },
    {
      key: 7, text: 'Event Admin', value: 'CORP_EVENT_ADMIN',
    },
    {
      key: 8, text: 'Event Organizer', value: 'CORP_EVENT_ORGANIZER',
    },
    {
      key: 9, text: 'System Operator', value: 'SYS_OPER',
    },
    {
      key: 10, text: 'Notification Operator', value: 'NOTIFICATION_OPERATOR',
    },
    {
      key: 11, text: 'Park User', value: 'PARK_USER',
    },
    {
      key: 12, text: 'Help Desk', value: 'HELP_DESK',
    },
    {
      key: 13, text: 'IVCA', value: 'IVCA'
    },
    {
      key: 14, text: 'Head Usher', value: 'HEAD_USHER',
    },
    {
      key: 15, text: 'Usher', value: 'USHER',
    },
    {
      key: 16, text: 'Security', value: 'SECURITY'
    },
  ];

export const receptionistUserRoles =
  [
    {
      key: 1, text: 'Receptionist', value: 'RECEPTION',
    },
    {
      key: 2, text: 'External Receptionist', value: 'EXTERNAL_RECEPTION',
    }
  ];
export const checkinTypes =
  [
    {
      key: 1, text: 'Visitor', value: 'VISITOTAGS_CHECKIN',
    },
    {
      key: 2, text: 'QR Check-In', value: 'QR_CHECKIN',
    }
  ];
export const tagsServices = [
  {
    key: 1, text: "Park", value: 1
  },
  {
    key: 2, text: "Visitor", value: 2
  },
  {
    key: 3, text: "Event", value: 3
  },
];
export const smsReports = [
  {
    label: 'MSISDN', field: '_1', sort: 'asc'
  },
  {
    label: 'SMS Body', field: '_2', sort: 'asc'
  },
  {
    label: 'Dispatch DateTime', field: '_3', sort: 'asc'
  },
  {
    label: 'Dispatch Status', field: '_4', sort: 'asc'
  },
  {
    label: 'Type Of SMS', field: '_5', sort: 'asc'
  },
  {
    label: 'Corporate', field: '_6', sort: 'asc'
  },
  {
    label: 'Tag Service', field: '_7', sort: 'asc'
  },
  ];

  // export const widgetsvisitors = [
  //   {
  //     label: 'Visitors',
  //     field: '_1',//     sort: 'asc'
  //   },

  //   ];

  //   export const widgetshost = [
  //     {
  //       label: 'Host',
  //       field: '_1',//       sort: 'asc'
  //     },

  //     ];

  //     export const widgetscompanies = [
  //       {
  //         label: 'Companies',
  //         field: '_1',//         sort: 'asc'
  //       },

  //       ];

  export const superMeetingReport = [
  {
    label: 'Corporate', field: '_1', sort: 'asc'
  },
  {
    label: 'Branch', field: '_2', sort: 'asc'
  },
  {
    label: 'Building', field: '_3', sort: 'asc'
  },
  {
    label: 'Floor', field: '_4', sort: 'asc'
  },
  {
    label: 'Host A', field: '_5', sort: 'asc'
  },
  {
    label: 'Host B', field: '_6', sort: 'asc'
  },
  {
    label: 'Meeting Purpose', field: '_7', sort: 'asc'
  },
  {
    label: 'Receptionist', field: '_8', sort: 'asc'
  },
  {
    label: 'Schedule Date & Time', field: '_9', sort: 'asc'
  },
  {
    label: 'Visitors', field: '_10', sort: 'asc'
  }
];
export const superMeetingReportViewVisitors = [
  {
    label: '', field: '_', sort: 'asc'
  },
  {
    label: 'Status', field: '_0', sort: 'asc'
  },
  {
    label: 'Name', field: '_1', sort: 'asc'
  },
  {
    label: 'Mobile', field: '_2', sort: 'asc'
  },
  {
    label: 'Identity', field: '_3', sort: 'asc'
  },
  {
    label: 'Email', field: '_4', sort: 'asc'
  },
  {
    label: 'Company', field: '_5', sort: 'asc'
  },
  {
    label: 'Checked In', field: '_6', sort: 'asc'
  },
  {
    label: 'Checked Out', field: '_7', sort: 'asc'
  },
  {
    label: 'Pass Number', field: '_8', sort: 'asc'
  },
  {
    label: 'WIFI Package', field: '_9', sort: 'asc'
  },
  {
    label: 'Vehicle No', field: '_10', sort: 'asc'
  },
  {
    label: 'Remark', field: '_11', sort: 'asc'
  },
  {
    label: 'Overdue Message', field: '_12', sort: 'asc'
  }
];


export const corporateAdminRoles = [
  {
    key: '1', text: 'Corporate Admin', value: 'CORP_ADMIN'
  },
  {
    key: '2', text: 'Corporate Event Admin', value: 'CORP_EVENT_ADMIN'
  }
];

export const identificationOfParticipants = [
    {
      key: 0, text: 'NIC', value: 'NIC',
    },
    {
      key: 1, text: 'Contact Number', value: 'CONTACT_NO',
    }
];

export const participantStatus = [
  {text: "PENDING", value: "PENDING",
    key: 0,
  },
  {text: "APPROVED", value: "APPROVED",
    key: 1,
  },
  {text: "REJECTED", value: "REJECTED",
    key: 2,
  }
];

export const private_participantStatus = [
  {text: "APPROVED", value: "APPROVED",
    key: 1,
  },
  {text: "REJECTED", value: "REJECTED",
    key: 2,
  }
];

export const tempCorporateStatus = [
  {
    key: 1, text: 'PENDING', value: 'PENDING'
  },
  {
    key: 2, text: 'REJECTED', value: 'REJECTED'
  },
  {
    key: 3, text: 'APPROVED', value: 'APPROVED'
  },
  {
    key: 4, text: 'ALL', value: 'ALL'
  }
];
export const qrCheckinBranchStatus = [
  {
    key: 1, text: 'GRANTED', value: 'Granted'
  },
  {
    key: 2, text: 'REJECTED', value: 'Rejected'
  },
  {
    key: 4, text: 'ALL', value: 'ALL'
  }
];

export const provinces = [
  {
    key: 0, text: 'Western Province', value: 'Western Province'
  },
  {
    key: 1, text: 'Southern Province', value: 'Southern Province'
  },
  {
    key: 2, text: 'North Central Province', value: 'North Central Province'
  },
  {
    key: 3, text: 'North Western Province', value: 'North Western Province'
  },
  {
    key: 4, text: 'Northern Province', value: 'Northern Province'
  },
  {
    key: 5, text: 'Sabaragamuwa Province', value: 'Sabaragamuwa Province'
  },
  {
    key: 6, text: 'Eastern Province', value: 'Eastern Province'
  },
  {
    key: 7, text: 'Uva Province', value: 'Uva Province'
  },
  {
    key: 8, text: 'Central Province', value: 'Central Province'
  },
]

export const districs = [

  {
    key: 'Ampara', text: 'Ampara', value: 'Ampara'
  },
  {
    key: 'Anuradhapura', text: 'Anuradhapura', value: 'Anuradhapura'
  },
  {
    key: 'Badulla', text: 'Badulla', value: 'Badulla'
  },
  {
    key: 'Batticaloa', text: 'Batticaloa', value: 'Batticaloa'
  },
  {
    key: 'Colombo', text: 'Colombo', value: 'Colombo'
  },
  {
    key: 'Galle', text: 'Galle', value: 'Galle'
  },
  {
    key: 'Gampaha', text: 'Gampaha', value: 'Gampaha'
  },
  {
    key: 'Hambantota', text: 'Hambantota', value: 'Hambantota'
  },
  {
    key: 'Jaffna', text: 'Jaffna', value: 'Jaffna'
  },
  {
    key: 'Kalutara', text: 'Kalutara', value: 'Kalutara'
  },
  {
    key: 'Kandy', text: 'Kandy', value: 'Kandy'
  },
  {
    key: 'Kegalle', text: 'Kegalle', value: 'Kegalle'
  },
  {
    key: 'Kilinochchi', text: 'Kilinochchi', value: 'Kilinochchi'
  },
  {
    key: 'Kurunegala', text: 'Kurunegala', value: 'Kurunegala'
  },
  {
    key: 'Mannar', text: 'Mannar', value: 'Mannar'
  },
  {
    key: 'Matale', text: 'Matale', value: 'Matale'
  },
  {
    key: 'Matara', text: 'Matara', value: 'Matara'
  },
  {
    key: 'Monaragala', text: 'Monaragala', value: 'Monaragala'
  },
  {
    key: 'Mullaitivu', text: 'Mullaitivu', value: 'Mullaitivu'
  },
  {
    key: 'NuwaraEliya', text: 'NuwaraEliya', value: 'NuwaraEliya'
  },
  {
    key: 'Polonnaruwa', text: 'Polonnaruwa', value: 'Polonnaruwa'
  },
  {
    key: 'Puttalam', text: 'Puttalam', value: 'Puttalam'
  },
  {
    key: 'Ratnapura', text: 'Ratnapura', value: 'Ratnapura'
  },
  {
    key: 'Trincomalee', text: 'Trincomalee', value: 'Trincomalee'
  },
  {
    key: 'Vavuniya', text: 'Vavuniya', value: 'Vavuniya'
  }
];

// copied from ViewAllCheckINReducer for language change in ViewAllCheckIn
export const selectCols = (t=null) => {
  return [
    {index: 'status', text: t !== null ? t('status') : 'Status', value: 'status' },
    {index: 'passNumber', text: t !== null ? t('pass_number') : 'Pass Number', value: 'passNumber'},
    {index: 'checkedIn', text: t !== null ? t('checked_in') : 'Checked In', value: 'checkedIn'},
    {index: 'checkedOut', text: t !== null ? t('checked_out') : 'Checked Out', value: 'checkedOut'},
    {index: 'host1', text: t !== null ? t('host_1') : 'Host1', value: 'host1'},
    {index: 'host1Mobile', text: t !== null ? t('host_1_mobile') : 'Host1 Mobile', value: 'host1Mobile'},
    {index: 'host2', text: t !== null ? t('host_2') : 'Host2', value: 'host2'},
    {index: 'host2Mobile', text: t !== null ? t('host_2_mobile') : 'Host2 Mobile', value: 'host2Mobile'},
    {index: 'visitorName', text: t !== null ? t('visitor') : 'Visitor', value: 'visitorName'},
    {
      index: 'visitorIdentity',
      text: t !== null ? t('visitor_identity') : 'Visitor Identity',
      value: 'visitorIdentity'
    },
    {
      index: 'visitorMobile',
      text: t !== null ? t('visitor_mobile') : 'Visitor Mobile',
      value: 'visitorMobile'
    },
    {index: 'company', text: t !== null ? t('company') : 'Company', value: 'company'},
    {
      index: 'visitingPurpose',
      text: t !== null ? t('purpose_of_visit') : 'Purpose of Visit',
      value: 'visitingPurpose'
    },
    {
      index: 'activatedPackage',
      text: t !== null ? t('activated_package') : 'Activated Package',
      value: 'activatedPackage'
    },
    {index: 'generatedPin', text: t !== null ? t('generated_pin') : 'Generated Pin', value: 'generatedPin'},
    {index: 'expireDate', text: t !== null ? t('expire_date') : 'Expire Date', value: 'expireDate'}
  ];
}

export const emailOptions = [
  {
    key: 1, text: 'Corporate', value: 'Corporate'
  },
  {
    key: 2, text: 'Personal', value: 'Personal'
  }
]
